import React from "react";
import { useNavigate } from "react-router-dom";
import { Book, FileText, MessageCircleQuestion, BrainCircuit, ChevronRight } from "lucide-react";
import { useLang } from "../../hooks/useLang";

const CATEGORY_ICON = { Book, Note: FileText, Exercise: MessageCircleQuestion, Quiz: BrainCircuit };

const timeAgo = (date) => {
  const diff = Date.now() - new Date(date).getTime();
  const days = Math.floor(diff / 86400000);
  if (days >= 7) return `${Math.floor(days / 7)}w ago`;
  if (days >= 1) return `${days}d ago`;
  const hours = Math.floor(diff / 3600000);
  if (hours >= 1) return `${hours}h ago`;
  return "just now";
};

// Renders nothing when the user follows nobody — an empty "people you follow"
// card on a fresh account is noise, not onboarding.
const FromYourNetwork = ({ uploads }) => {
  const navigate = useNavigate();
  const { urlLanguage } = useLang();

  if (!uploads?.length) return null;

  return (
    <div className="mb-6">
      <h2 className="section-title mb-3 uppercase tracking-wider">New from people you follow</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {uploads.map((item) => {
          const Icon = CATEGORY_ICON[item.category] || FileText;
          return (
            <button
              key={item.id}
              onClick={() => navigate(urlLanguage(`/material/${item.id}`))}
              className="group flex items-center gap-3 p-3 rounded-2xl bg-card border border-border/40 hover:border-primary/40 text-left transition-colors cursor-pointer"
            >
              <div className="relative w-11 h-11 rounded-xl overflow-hidden bg-primary/10 text-primary flex items-center justify-center flex-shrink-0">
                {item.cover_url ? (
                  <img src={item.cover_url} alt="" className="absolute inset-0 w-full h-full object-cover" />
                ) : (
                  <Icon size={18} />
                )}
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-xs font-bold text-foreground truncate">{item.title}</p>
                <p className="text-[11px] text-muted-foreground truncate mt-0.5">
                  {item.author?.name || "Someone you follow"} · {timeAgo(item.createdAt)}
                </p>
              </div>
              <ChevronRight size={14} className="text-muted-foreground/40 flex-shrink-0 group-hover:translate-x-0.5 transition-transform" />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FromYourNetwork;
